module.exports = __webpack_public_path__ + "img/cash.36b3532a.png";